import CitySEOHead from "@/components/feature/CitySEOHead";
import FortLauderdaleHeroSection from "./components/HeroSection";
import FortLauderdaleStickyNav from "./components/StickyNav";
import FortLauderdaleProcessingTimeSection from "./components/ProcessingTimeSection";
import FortLauderdaleServicesSection from "./components/ServicesSection";
import FortLauderdaleLocalAreaSection from "./components/LocalAreaSection";
import FortLauderdaleTravelTimingSection from "./components/TravelTimingSection";
import FortLauderdaleDestinationsSection from "./components/DestinationsSection";
import FortLauderdaleTestimonialsSection from "./components/TestimonialsSection";
import FortLauderdaleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import FortLauderdaleComparisonSection from "./components/ComparisonSection";
import FortLauderdaleMistakesSection from "./components/MistakesSection";
import FortLauderdaleHowItWorksSection from "./components/HowItWorksSection";
import FortLauderdaleFAQSection, { faqs } from "./components/FAQSection";
import FortLauderdaleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FortLauderdaleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function FortLauderdalePage() {
  return (
    <>
      <CitySEOHead
        city="Fort Lauderdale"
        state="Florida"
        stateAbbr="FL"
        route="/cities/fort-lauderdale"
        title="Emergency Passport Fort Lauderdale, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Fort Lauderdale, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers, cruise passengers, and yacht crews."
        ogTitle="Emergency Passport Fort Lauderdale, FL — Expedited & Fast Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in Fort Lauderdale, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers, cruise passengers, and yacht crews."
        twitterTitle="Emergency Passport Fort Lauderdale, FL — Expedited & Fast Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in Fort Lauderdale, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers, cruise passengers, and yacht crews."
        keywords="expedited passport Fort Lauderdale, emergency passport Fort Lauderdale FL, same day passport Fort Lauderdale, fast passport Florida, passport renewal Fort Lauderdale, Fort Lauderdale passport courier"
        geoPlacename="Fort Lauderdale, Florida"
        geoPosition="26.1224;-80.1373"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <div className="font-sans">
        <FortLauderdaleHeroSection />
        <FortLauderdaleStickyNav />
        <FortLauderdaleProcessingTimeSection />
        <FortLauderdaleLocalAreaSection />
        <FortLauderdaleServicesSection />
        <FortLauderdaleTravelTimingSection />
        <FortLauderdaleDestinationsSection />
        <FortLauderdaleTestimonialsSection />
        <FortLauderdaleAcceptanceFacilitiesSection />
        <FortLauderdaleComparisonSection />
        <FortLauderdaleMistakesSection />
        <FortLauderdaleHowItWorksSection />
        <FortLauderdaleFAQSection />
        <FortLauderdaleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/fort-lauderdale" state="FL" />
        <FortLauderdaleFinalCTA />
      </div>
    </>
  );
}